import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface VoiceWaveformProps {
  isActive?: boolean;
}

const WaveformContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '40px',
  width: '120px',
  marginRight: theme.spacing(2),
}));

const WaveBar = styled(Box)<{ height: number; delay: number; isActive: boolean }>(({ theme, height, delay, isActive }) => ({
  width: '4px',
  height: isActive ? `${height}px` : '5px',
  margin: '0 2px',
  backgroundColor: isActive ? '#FF6F00' : 'rgba(255, 255, 255, 0.3)',
  borderRadius: '2px',
  transition: 'height 0.2s ease',
  animation: isActive ? `waveAnimation 1.2s infinite ${delay}s` : 'none',
  '@keyframes waveAnimation': {
    '0%, 100%': {
      height: '5px',
    },
    '50%': {
      height: `${height}px`,
    },
  },
}));

const VoiceWaveform: React.FC<VoiceWaveformProps> = ({ isActive = false }) => {
  const [bars, setBars] = useState<{ height: number; delay: number }[]>([]);

  useEffect(() => {
    // Generate random heights and delays for the wave bars
    const newBars = Array.from({ length: 12 }, () => ({
      height: Math.floor(Math.random() * 25) + 10, // Random height between 10 and 35
      delay: Math.random() * 0.5, // Random delay between 0 and 0.5 seconds
    }));
    setBars(newBars);
  }, []);

  return (
    <WaveformContainer>
      {bars.map((bar, index) => (
        <WaveBar 
          key={index} 
          height={bar.height} 
          delay={bar.delay} 
          isActive={isActive}
        />
      ))}
    </WaveformContainer>
  );
};

export default VoiceWaveform;